import { IconButton } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import { format, parseISO } from 'date-fns';
import React, { useState } from 'react';

import useTypedSWR from 'src/components/general/useTypedSWR';
import { StatusReviewDialog } from 'src/idVerification/components/StatusReviewDialog';
import { GET_ID_VERIFICATION_DATA } from 'src/idVerification/queries/getIdVerificationData.gql';

export const StatusReview = ({ patientId }: { patientId: string }) => {
  const { data, mutate } = useTypedSWR([
    GET_ID_VERIFICATION_DATA,
    {
      patientId,
    },
  ]);

  const [isEditing, setIsEditing] = useState(false);

  if (!data) {
    return null;
  }

  const { identityVerificationStatus, identityVerificationDueDate } =
    data.staff_getIdVerificationData;

  return (
    <div
      style={{
        paddingLeft: 10,
        display: 'flex',
      }}
    >
      <div style={{ gap: 50, display: 'flex', alignItems: 'center' }}>
        <span>Status: {identityVerificationStatus?.label}</span>
        <span>
          Due date:{' '}
          {identityVerificationDueDate && format(parseISO(identityVerificationDueDate), 'P')}
        </span>
      </div>
      <IconButton
        onClick={() => {
          setIsEditing(true);
        }}
      >
        <EditIcon />
      </IconButton>
      <StatusReviewDialog
        isOpen={isEditing}
        onClose={() => setIsEditing(false)}
        verificationData={data.staff_getIdVerificationData}
        patientId={patientId}
        mutate={mutate}
      />
    </div>
  );
};
